import { apiConfig } from './config';
import { useApi } from './use-api-call';

export interface TicketDTO {
    id?: number;
    userId: number;
    userName?: string;
    subject: string;
    category: string;
    priority: string;
    status: string;
    userLicenseId?: number;
    createdAt?: string;
    updatedAt?: string;
    closedAt?: string;
    assignedToAdminId?: number;
}

export interface TicketMessageDTO {
    id?: number;
    ticketId: number;
    senderId: number;
    senderType: string;
    senderName?: string;
    message: string;
    attachmentPath?: string;
    isRead: boolean;
    createdAt?: string;
}

export interface TicketSearchResult {
    tickets: TicketDTO[];
    totalCount: number;
    allowEdit: boolean;
}

export interface TicketDetailResult {
    ticket: TicketDTO;
    messages: TicketMessageDTO[];
}

export interface TicketSearchRequest {
    status?: string;
    category?: string;
    priority?: string;
    userId?: number;
    pageIndex?: number;
    pageSize?: number;
}

// Search tickets
export const useSearchTicketsApi = () =>
    useApi<TicketSearchResult>('/admin/tickets/search');

// Get ticket by ID
export const useGetTicketByIdApi = () =>
    useApi<TicketDetailResult>('/admin/ticket/get-ticket/{ticketId}');

// Send admin message
export const useSendAdminMessageApi = () =>
    useApi<{ message: TicketMessageDTO }>('/admin/ticket/send-message');

// Update ticket status
export const useUpdateTicketStatusApi = () =>
    useApi<{ ticket: TicketDTO }>('/admin/ticket/update-status');

// Assign ticket to admin
export const useAssignTicketApi = () =>
    useApi<{ ticket: TicketDTO }>('/admin/ticket/assign');

// Close ticket
export const useCloseTicketApi = () =>
    useApi('/admin/ticket/close-ticket/{ticketId}');

